<template>
    <div class="header-container mt-2 mb-3 mb-sm-0">
        <h1 class="header">Verify your identity</h1>
        <h4 class="sub-header mt-2">Let’s verify your identity so you can access the Autodesk employee network.</h4>
    </div>
</template>

<script>
export default {
    name: "IdentityVerificationHeader",
};
</script>

<style scoped>
.header-container {
    max-width: 1200px;
    width: 100%;
    padding: 0px 30px;
}

.header {
    font-size: 22px;
    font-weight: 700;
    color: black;
    font-family: artifaktElementBold;
    line-height: 34px;
    margin: 0px;
}

.sub-header {
    font-size: 16px;
    color: black;
    font-family: artifaktElementBold;
}

@media (max-width: 700px) {
    .header-container {
        width: 100%;
        padding: 0px;
        margin-bottom: 20px !important;
    }

    .header {
        font-size: 24px;
    }

    .sub-header {
        font-size: 16px;
    }
}
</style>